export const RadioOptions = [
  {
    id: 1,
    label: 'Assesment',
    value: 'ASSESMENT',
  },
  {
    id: 2,
    label: 'Group Discussion',
    value: 'GROUP',
  },
  {
    id: 3,
    label: 'Interview',
    value: 'FACE_TO_FACE',
  },
  {
    id: 4,
    label: 'External Assessment',
    value: 'EXTERNAL_ASSESMENT',
  },
]

export const assessmentOptions = [
  {
    id: 1,
    label: 'Cognitive',
    value: 'COGNITIVE',
  },
  {
    id: 2,
    label: 'Technical',
    value: 'TECHNICAL',
  },
  {
    id: 3,
    label: 'Communication',
    value: 'COMUNICATION',
  },
]

export const optionTime = []

const rangeOfNumbers = (startNum, endNum) => {
  if (endNum - startNum >= 0) {
    optionTime.push({
      value: startNum,
      label: `${startNum} Mins`,
    })
    return rangeOfNumbers(startNum + 5, endNum)
  } else {
    return optionTime
  }
}

rangeOfNumbers(5, 240)

export const RadioDriveOptions = [
  {
    id: 1,
    label: 'Written',
    value: 'ASSESMENT',
  },
  {
    id: 2,
    label: 'Group',
    value: 'GROUP',
  },
  {
    id: 3,
    label: 'Face-to-Face',
    value: 'FACE_TO_FACE',
  },
  {
    id: 4,
    label: 'External Assessment',
    value: 'EXTERNAL_ASSESMENT',
  },
]

export const getYearText = yearNumber => {
  let yearText
  if (yearNumber === 1) {
    yearText = yearNumber + ' year'
  } else if (yearNumber > 1) {
    yearText = yearNumber + ' years'
  } else {
    yearText = ''
  }
  return yearText
}

export const getMonthText = monthNumber => {
  let monthText
  if (monthNumber === 1) {
    monthText = monthNumber + ' month'
  } else if (monthNumber > 1) {
    monthText = monthNumber + ' months'
  } else {
    monthText = ''
  }
  return monthText
}

export const getDifferInMonthText = diffInMonths => {
  let diffInMonthsText
  if (diffInMonths === 1) {
    diffInMonthsText = diffInMonths + ' month'
  } else if (diffInMonths > 1) {
    diffInMonthsText = diffInMonths + ' months'
  } else {
    diffInMonthsText = ''
  }
  return diffInMonthsText
}

export const getCandidateText = count => {
  return count > 1 ? 'candidates' : 'candidate'
}

export const normalizeBooleanCondition = value => {
  return value === true || value === 'true'
}

// Skill arrays (`skills`, `skill_set`) can carry null/nameless entries — ERP
// imports write `[null]` into student.current_course.skills — which crash any
// renderer that reads `skill.name`. Always render through this.
export const getNamedSkills = skills => {
  return Array.isArray(skills) ? skills.filter(skill => skill?.name) : []
}
